<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item['@id']}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-party-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('id') }}</strong></td>
              <td>
                {{ item['@id']}}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('sepaInfo') }}</strong></td>
              <td>
                <sepa-info-table :item="item['sepaInfo']"></sepa-info-table>
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';
import SepaInfoTable from "../../components/party/SepaInfoTable";

const servicePrefix = 'Party';

export default {
  name: 'PartyShow',
  servicePrefix,
  components: {
      SepaInfoTable,
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('party', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('party', ['find'])
  },
  methods: {
    ...mapActions('party', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load',
        subscribe: 'mercureOpen'
    })
  },
    created() {
      setTimeout(() => {
          this.subscribe({ hubURL: new URL('http://localhost:1337/.well-known/mercure'), topics: [this.item['@id']] });
      }, 2000);
    }
};
</script>
